<div class="section-container card-shadow">
  <!--<div class="section-header">
    <img class="icon" src="{{icon}}" alt="section icon">
    <h4 class="title">{{title}}</h4>
  </div>-->
  <div class="section-header">
    <app-search-filter *ngIf="showSearchFilter"
                       (selectionChange)="filterItemsByString($event)"></app-search-filter>
    <span *ngIf="votingControl.submissionMode" #selectionInfo
          class="selection-info" [class.selected]="nrSelectedItems > 0">
      {{selectionInfoText}}
    </span>
  </div>
  <ng-container *ngFor="let item of displayedItems; let i = index">
    <app-voting-item [item]="item" (selectionToggle)="onSelectionChanged(item, $event)"></app-voting-item>
    <lib-ad
      *ngIf="adItemIndex === i && displayedItems?.length > 2"
      class="my-1"
    ></lib-ad>
  </ng-container>

</div>
